import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { IUser } from "app/auth/user.model";
import { IonicPage, NavParams, ViewController } from "ionic-angular"; //NavController, NavParams } from 'ionic-angular';
import { AuthService } from "../../../app/auth/auth.service";
import { CareType } from "../../../models/patient-chart/care-type";
import {
  AppStatus,
  ConnectionStatusEnum,
} from "../../../providers/app-status/app-status";
import { ConfigurationService } from "../../../providers/configuration/configuration.service";
import { EvaService } from "../../../providers/eva/eva.service";
import { MobileUtilsProvider } from "../../../providers/mobile-utils/mobile-utils";
import { StateManagementService } from "../../../providers/state-management/state-management.service";
import { UtilityService } from "../../../providers/utility-service/utility-service";
import { NavigationService } from "../../navigation.service";

/**
 * Generated class for the UserPopoverPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "user-popover",
  templateUrl: "user-popover.html",
})
export class UserPopoverPage implements OnInit {
  user: IUser;
  dataUrl: string;
  isMobilePlatform: boolean;
  appSyncStatus: ConnectionStatusEnum;
  connectionStatusEnum = ConnectionStatusEnum;
  popoverClass: string = "popover"; // holds the css class for updating the popover bg color.
  private isNewAlertToggleOn: boolean;
  isAskEvaToggleOn: boolean = false;
  appVersion: string;
  appBuild: string;

  constructor(
    public navSvc: NavigationService,
    public viewCtrl: ViewController,
    public navParams: NavParams,
    private translate: TranslateService,
    private authSvc: AuthService,
    public mobileUtilsProvider: MobileUtilsProvider,
    public appStatus: AppStatus,
    public stateData: StateManagementService,
    public configurationServer: ConfigurationService,
    public utilService: UtilityService,
    public evaService: EvaService
  ) {
    // remove check of environment once all issues are resolved
    if (
      this.configurationServer.getConfig().isLocal ||
      this.configurationServer.getConfig().isDev ||
      this.configurationServer.getConfig().isQA
    ) {
      // set css class (to update the background color) of user-popover
      if (
        this.stateData.patientCareType &&
        this.stateData.patientCareType.toLowerCase() ===
          CareType[CareType.Palliative].toLowerCase() &&
        (this.utilService.isDynamicGlobalHeader(
          this.stateData.getAssessmentType(),
          "assessmentType"
        ) ||
          this.utilService.isDynamicGlobalHeader(
            this.stateData.getCurrentPage(),
            "currentPage"
          ) ||
          this.utilService.isDynamicGlobalHeader(
            this.stateData.getSectionId(),
            "sectionId"
          ))
      ) {
        this.popoverClass = "popover-palliative"; // see 'popover.scss' for more details on this css class
      }
    }
    this.isMobilePlatform = mobileUtilsProvider.isMobilePlatform();
    this.dataUrl =
      configurationServer.getConfig().logoutUrl +
      "?tenantId=" +
      this.authSvc.getUser().tenantId;
    this.user = authSvc.getUser();
    this.appSyncStatus = this.appStatus.getAppStatus();
    this.appVersion = this.configurationServer.getConfig().appVersion;
    this.appBuild = this.configurationServer.getConfig().appBuild;
  }

  ngOnInit(): void {
    this.stateData.showNewAlerts.subscribe((value) => {
      this.isNewAlertToggleOn = !!value;
    });
    this.stateData.askEvaToggle.subscribe((value) => {
      this.isAskEvaToggleOn = !!value;
    });
  }

  close() {
    this.viewCtrl.dismiss();
  }

  changeTranslation(lang) {
    this.translate.use(lang);
  }

  redirect(id: string) {
    this.viewCtrl.dismiss();
    this.navSvc.clearPatientSessionContext();
    this.navSvc.goToInternalPage(id, {});
  }

  public signOut(): void {
    this.viewCtrl.dismiss("sign-out-cognito");
  }

  launchHelp() {
    window.open(
      "https://curantissolutions.atlassian.net/wiki/spaces/CSKBU/overview?homepageId=3196682498"
    );
  }

  launchEva() {
    this.viewCtrl.dismiss();
    this.evaService.open();
  }

  navigateToUserSettings() {
    if (!this.isNewAlertToggleOn) {
      this.close();
      return;
    }
    this.redirect("MyAlertsPage");
  }
}



// WEBPACK FOOTER //
// ./src/navigation/components/user-popover/user-popover.ts